import { Component, Inject, Input, OnInit, ViewEncapsulation, PLATFORM_ID, OnDestroy } from '@angular/core';
import { skip } from 'rxjs/operators';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { WizumenService } from 'projects/common/services/wizumen.service';
import { EmpireStateCode, ProductAmount, WizumenModel, WizumenStatusResolver } from '../../wizumen-models';

import { isPlatformBrowser } from '@angular/common';
import { Device } from 'projects/common/model/Device';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { DropdownService } from 'projects/common/components/user-landings-v2/dropdown.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wizumen-item',
  template: `
    <div class="eva-3-card wizumenV2Feature">

      <wizumen-collapsed
        *ngIf="isDesktop && !isOpenDropdownIterationsV2"
        [item]="item"
        [layoutInfo]="layoutInfo"
        [device]="device"
        [moduleId]="moduleId"
        [moduleIndex]="moduleIndex"
        [uniqueId]="uniqueId"
        ></wizumen-collapsed>

      <div *ngIf="isOpenDropdownIterationsV2 || !isDesktop"
      class="wizumen-item flex-column {{itemStatus}}"
      (click)="openDropdown()">
        <div class="wizumen-detail-container" [ngClass]="{'wizumen-detail-container-tpv3': isTPV3Desktop}">
          <wizumen-detail-header
          [item]="item"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [uniqueId]="uniqueId"
          [purchasedProductsAmount]="purchasedProductsAmount"
          [missingProductsAmount]="missingProductsAmount"
          [goToMyTravels]="goToMyTravels"
          [isTPV3Desktop]="isTPV3Desktop"
          [isDesktopWizumenV2]="isDesktopWizumenV2"
          [device]="device"
          [layoutInfo]="layoutInfo"
          [showDestinationImage]="isDesktopWizumenV2 && !isTPV3Desktop"
          [showProducts]="!isDesktopWizumenV2"
          [showDateAndPassengers]="!isDesktopWizumenV2"
          [showContent]="!isDesktopWizumenV2"
          [hasTripPlanner]="!!item.wizumen_trip_planner"
          ></wizumen-detail-header>

          <wizumen-trip-planner *ngIf="isDesktopWizumenV2 && item.wizumen_trip_planner"
            [wizumenTripPlanner]="item.wizumen_trip_planner"
            [moduleId]="moduleId"
            [moduleIndex]="moduleIndex"
            [uniqueId]="uniqueId"
            [device]="device"
            [sizeImage]="'92x76'">
          </wizumen-trip-planner>
        </div>


        <div *ngIf="!this.item.wizumen_v2" class="wizumen-footer -border-top flex align-center">
          <button *ngIf="itemStatus === 'CONFIRMED'; else unconfirmed"
              (click)='openWizumenDetailModal()' name=""
              class="eva-3-btn -md -primary wizumen-footer-button open-modal">
              <em class="btn-text wizumen-footer-link-text">
                  {{item.button_text}}
              </em>
          </button>

          <ng-template #unconfirmed>
              <button *ngIf="item.booking_info.open; else footer_link"
                  (click)='goToMyTravels()' name=""
                  class="eva-3-btn -md -primary wizumen-footer-button">
                  <em class="btn-text wizumen-footer-link-text">
                      {{item.button_text}}
                  </em>
              </button>
          </ng-template>

          <ng-template #footer_link>
              <a class="wizumen-footer-link eva-3-link" (click)="trackItemClick(true)" href='{{myTravelsHref}}'>
                  <em class="wizumen-footer-link-text">
                      {{item.button_text}}
                  </em>
                  <i class="eva-3-icon-chevron-right eva-icon"></i>
              </a>
          </ng-template>
        </div>

        <div  class="wizumen-detail-products-container">
          <wizumen-detail-dropdown *ngIf="this.item.wizumen_v2 && item.list_items"
                    [ngClass]="{'flex-1': isDesktop}"
                    [item]="item"
                    [flow]="flow"
                    [tripId]="this.item.trip_id"
                    [myTravelsHref]="this.myTravelsHref"
                    [moduleId]="moduleId"
                    [moduleIndex]="moduleIndex"
                    [uniqueId]="uniqueId"
                    [products]="item.list_items"
                    [xSellBanner]="item.xsell_banner"
                    [tripStatus]="this.item.trip_status"
                    [isActive]="isOpenDropdown || isDesktopWizumenV2"
                    [isDesktopWizumenV2]="isDesktopWizumenV2"
                    [hasAllProducts]="hasAllProducts"
                    [layoutInfo]="layoutInfo"
                    [isTPV3Desktop]="isTPV3Desktop"
                    [locale]="locale"
                    [device]="device"
                    (click)="$event.stopPropagation()"
                    (onToggle)="toggleDropdown($event)"
                    [purchasedProductsAmount]="purchasedProductsAmount"
                    [missingProductsAmount]="missingProductsAmount"
                    [goToMyTravels]="goToMyTravels"
                    ></wizumen-detail-dropdown>
        </div>
        <div *ngIf="isDesktop" class="wizumen-xsell-container">
          <incentive-xsell
            [flow]="flow"
            [locale]="locale"
            [device]="device"
            [myTravelsHref]="myTravelsHref"
            [moduleId]="moduleId"
            [uniqueId]="uniqueId"
            [moduleIndex]="moduleIndex"
            [xSellBanner]="item.xsell_banner"
            [hasNoAssistanceOffer]="!item.travel_assistance"
            [hasTripPlanner]="!!item.wizumen_trip_planner"
            [dropdownOpened]="isOpenDropdown || isDesktopWizumenV2">
          </incentive-xsell>
          <wizumen-travel-assistance *ngIf="item.travel_assistance" 
            [travelAssistance]="item.travel_assistance"
            [locale]="locale"
            [moduleId]="moduleId"
            [moduleIndex]="moduleIndex"
            [uniqueId]="uniqueId"
            [flow]="flow">
          </wizumen-travel-assistance>
        </div>
      </div>
      <incentive-xsell *ngIf="hasAllProducts"
        [flow]="flow"
        [myTravelsHref]="myTravelsHref"
        [moduleId]="moduleId"
        [uniqueId]="uniqueId"
        [moduleIndex]="moduleIndex"
        [product]="finalXsellProduct"
        [hasAllProducts]="true"
        [dropdownOpened]="isOpenDropdown || isDesktopWizumenV2"
        [xSellBanner]="item.xsell_banner"
        [hasNoAssistanceOffer]="!item.travel_assistance"
        [hasTripPlanner]="!!item.wizumen_trip_planner">
      </incentive-xsell>
    </div>
  `,
  styleUrls: ['../../wizumen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenItemComponent implements OnInit, OnDestroy {
  @Input() item: WizumenModel;
  @Input() flow: string;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() isOpenDropdown: boolean;
  @Input() isTPV3Desktop: boolean;
  @Input() locale: string;
  @Input() device: Device;
  @Input() isCollapsedByDefault: boolean = false;

  itemStatus: EmpireStateCode;
  layoutInfo: string;
  myTravelsHref: string = "/me/bookings?as_referer=home-wizumen";
  purchasedProducts: number;
  totalProducts: number;
  isDesktop: boolean;
  isDesktopWizumenV2: boolean = false;
  hasAllProducts: boolean;
  finalXsellProduct;
  purchasedProductsAmount: ProductAmount[];
  missingProductsAmount: ProductAmount[];
  isOpenDropdownIterationsV2: boolean = true;
  isWizumenCollapsedOnEventsAB: boolean = false;
  isDropdownOpenSubscription: Subscription;

  constructor(private wizumenService: WizumenService, private upaService: UpaService, private mediaPictureService: MediaPictureService, @Inject(PLATFORM_ID) private platformId: string, private landingModelService: LandingModelService, private dropdownService: DropdownService) {
  }

  ngOnInit() {
    // TODO: Borrar cuando termine el AB
    this.isWizumenCollapsedOnEventsAB = this.landingModelService.getLandingModel().abTests?.ab.includes("wizumenCollapsedOnEvents|enabled_true");
    
    if (isPlatformBrowser(this.platformId)) {
      this.isDesktop = window.innerWidth >= 767;
      this.setInitialDropdownState();
      this.dropdownService.setInitialState(this.isOpenDropdownIterationsV2);
      this.isDropdownOpenSubscription = this.setupDropdownSubscription();
    } else if (this.isWizumenCollapsedOnEventsAB) {
      this.isOpenDropdownIterationsV2 = !this.isCollapsedByDefault;
    }

    this.itemStatus = this.item.booking_info.status;
    this.layoutInfo = WizumenStatusResolver.getDriverInfo(this.itemStatus);

    if (this.item.wizumen_v2) {
      this.totalProducts = this.item.products.length;
      this.purchasedProducts = this.item.products.filter(item => item.amount > 0).length;
      if (this.isDesktop) {
        this.hasAllProducts = this.purchasedProducts >= this.item.products.length;
        this.finalXsellProduct = this.item.list_items?.find(product => product.type.includes("XSELL_FINAL"));
        this.purchasedProductsAmount = this.item.products.filter(product => product.amount > 0);
        this.missingProductsAmount = this.item.products.filter(product => product.amount === 0);
        this.isDesktopWizumenV2 = true;
      } else {
        this.isOpenDropdown = true;
      }
    }
  }

  ngOnDestroy() {
    this.isDropdownOpenSubscription?.unsubscribe();
  }

  public openWizumenDetailModal() {
    this.trackItemClick(false);

    this.wizumenService.openModal(this.flow, this.myTravelsHref, this.moduleId, this.moduleIndex, this.uniqueId, this.item.trip_id, this.item.trip_status);
  }

  public goToMyTravels() {
    this.trackItemClick(true);

    window.open(this.myTravelsHref, '_blank');
  }

  public trackItemClick(isRedirect: boolean): void {
    this.upaService.trackClickTopic({
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.WIZUMEN_MODAL,
      label: "show",
      href: isRedirect ? this.myTravelsHref : undefined,
      dc: isRedirect ? undefined : this.item.to_city_code,
      uniqueId: this.uniqueId
    })
  }

  public openDropdown() {
    if (this.item.wizumen_v2 && !this.isDesktop && !this.isOpenDropdown) {
      this.isOpenDropdown = !this.isOpenDropdown;
      this.trackDropdownClick(this.isOpenDropdown);
    }
  }

  public toggleDropdown(event: boolean) {
    this.isOpenDropdown = event;
    this.trackDropdownClick(event);
  }

  public trackDropdownClick(toggle: boolean): void {
    this.upaService.trackClickTopic({
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.WIZUMEN,
      label: `${toggle ? 'open' : 'close'}-dropdown`,
      uniqueId: this.uniqueId
    })
  }

  public getMediaSrc(mediaKeyOrUrl: string): string {
    return this.mediaPictureService.getMediaUrl(mediaKeyOrUrl, "420x272") || "";
  }

  private setInitialDropdownState() {
    // Borrar condición cuando termine el AB
    if (this.isWizumenCollapsedOnEventsAB) {
      const savedState = localStorage.getItem('isOpenDropdownIterationsV2');

      if (savedState !== null) {
        this.isOpenDropdownIterationsV2 = JSON.parse(savedState);
      } else {
        this.isOpenDropdownIterationsV2 = !this.isCollapsedByDefault;
      }
    }
  }

  private setupDropdownSubscription(): Subscription {
    return this.dropdownService.isDropdownOpen$
        .pipe(skip(1))
        .subscribe((state) => {
          if (this.isOpenDropdownIterationsV2 !== state) {
            this.isOpenDropdownIterationsV2 = state;

            if (this.isWizumenCollapsedOnEventsAB) localStorage.setItem('isOpenDropdownIterationsV2', JSON.stringify(state));
          }
        });
  }
}
